import {myStorage} from '../utils/localStorage'

export default {
    data() {
        return {
            showTimeInfo: false, //判断是否显示弹窗
            status: 0,// 0过期  1开通剩余时间小于三天
        }
    },
    methods: {
        /**
         * 已开通，即将到期的（剩余时长小于等于3天的，大于0小时）  此弹窗每天至多弹一次，每天24点刷新次数
         * 已开通，已过期     此弹窗每周至多弹一次，每周日24点刷新次数
         */
        judgeTip() {
            if (this.$root.indexInfo.speedUpType === 2) {
                this.status = 0
                //过期的弹窗
                const now = new Date()
                const nowDay = new Date(new Date().toLocaleDateString()).getTime()
                // getDay()返回0-6，其中0表示周日，需特殊处理
                const day = now.getDay() > 0 ? now.getDay() : 7 // 表示当前是周几
                const oneDayTime = 24 * 60 * 60 * 1000 // 一天的总ms
                // 下周一的时间时间戳
                const nextWeekTime = nowDay + (8 - day) * oneDayTime
                const  times = nextWeekTime - new Date().getTime()
                let storage = new myStorage('coupon-week-pop')
                if (!storage.getItem()) {
                    //不存在弹窗标识 或者弹窗间隔时间已过
                    this.showTimeInfo = true
                    storage.setItem('week', times)
                }
            } else {
                if (this.$root.indexInfo.expireTime) {
                    const expireTime = this.$root.indexInfo.expireTime
                    const endDay = new Date(expireTime).getTime()
                    const nowDay = new Date(new Date().toLocaleDateString()).getTime()
                    // 开通且剩余时间小于三天
                    if (endDay > nowDay && (endDay - nowDay) <= 345600000) {
                        this.status = 1
                        let storage = new myStorage('coupon-day-pop')
                        if (!storage.getItem()) {
                            //不存在弹窗标识 或者弹窗间隔时间已过
                            this.showTimeInfo = true
                            storage.setItem('day', 'fixed')
                        }
                    }
                }
            }


        }
    },
    created() {

    },
    watch: {
        'indexInfo': {
            handler(val) {
                if (val) {
                    this.judgeTip()
                }
            },
            deep: true,
            immediate: true
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/mixin/renewCoupon.js